// app/javascript/controllers/dae20/source_filters_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "filterRow"]

  connect() {
    console.log("[dae20] Source filters controller connected")
    this.addEventListenersToExistingRows()
  }

  addEventListenersToExistingRows() {
    // Ищем только внутри своего элемента, а не по всему document
    const filterRows = this.element.querySelectorAll('.source-filter-row')
    filterRows.forEach(row => {
      // Слушаем все select-ы в строке (поле + тип значения)
      const selects = row.querySelectorAll('select')
      const input = row.querySelector('input[type="text"]')

      selects.forEach(select => {
        if (!select.hasAttribute('data-filter-listener-added')) {
          select.addEventListener('change', () => this.notifyPreviewController())
          select.setAttribute('data-filter-listener-added', 'true')
        }
      })

      if (input && !input.hasAttribute('data-filter-listener-added')) {
        input.addEventListener('input', () => this.notifyPreviewController())
        input.setAttribute('data-filter-listener-added', 'true')
      }
    })
  }

  addFilter() {
    const template = this.templateTarget
    if (!template) {
      console.error("[dae20] Source filter template not found")
      return
    }

    // Клонируем содержимое template
    const filterRow = template.content.firstElementChild.cloneNode(true)

    // Генерируем уникальный индекс
    const uniqueIndex = Date.now() + Math.random().toString(36).substr(2, 9)

    // Заменяем TEMPLATE_KEY на уникальный индекс во всех атрибутах
    this.replaceTemplateKey(filterRow, uniqueIndex)

    // Добавляем строку в контейнер
    this.containerTarget.appendChild(filterRow)

    // Уведомляем о изменении
    this.notifyPreviewController()
  }

  replaceTemplateKey(element, newKey) {
    // Заменяем в name атрибутах (глобально, т.к. TEMPLATE_KEY может встретиться дважды)
    element.querySelectorAll('[name*="TEMPLATE_KEY"]').forEach(el => {
      el.name = el.name.replace(/TEMPLATE_KEY/g, newKey)
    })

    // Заменяем в id атрибутах
    element.querySelectorAll('[id*="TEMPLATE_KEY"]').forEach(el => {
      el.id = el.id.replace(/TEMPLATE_KEY/g, newKey)
    })

    // Заменяем в for атрибутах labels
    element.querySelectorAll('label[for*="TEMPLATE_KEY"]').forEach(el => {
      el.htmlFor = el.htmlFor.replace(/TEMPLATE_KEY/g, newKey)
    })
  }

  // Вызывается через data-action на полях
  notifyPreview() {
    this.notifyPreviewController()
  }

  removeFilter(event) {
    const row = event.target.closest('.source-filter-row')
    if (row) {
      row.remove()
      this.notifyPreviewController()
    }
  }

  // Уведомляем контроллер предварительного просмотра dae20--preview
  notifyPreviewController() {
    // Ищем элемент с контроллером dae20--preview (может содержать несколько контроллеров)
    const previewElement = document.querySelector('[data-controller*="dae20--preview"]')
    if (!previewElement) return

    const previewController = this.application.getControllerForElementAndIdentifier(
      previewElement,
      'dae20--preview'
    )

    if (previewController && typeof previewController.loadRecordCount === 'function') {
      previewController.loadRecordCount()
    }
  }
}
